module.exports = __webpack_public_path__ + "img/csr_110923_J.512d794c.jpg";